import type { SVGProps } from 'react';
const SvgDocumentGenerationPage1 = (props: SVGProps<SVGSVGElement>) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={100}
      height={100}
      fill="none"
      className="w-full h-full"
      viewBox="0 0 100 100"
      {...props}
   >
      <path
         className="stroke-primary"
         strokeLinejoin="round"
         strokeWidth={5}
         d="M46.36 24H21a7 7 0 0 0-7 7v50a7 7 0 0 0 7 7h36a7 7 0 0 0 7-7V40.96z"
      />
      <path
         className="stroke-primary"
         strokeLinejoin="round"
         strokeWidth={5}
         d="M64 41H46V24z"
      />
      <path
         className="stroke-primary"
         strokeLinecap="round"
         strokeWidth={5}
         d="M24 77h21M24 66h16M24 54h27"
      />
      <path
         className="stroke-primary"
         strokeLinejoin="round"
         strokeWidth={5}
         d="M75.352 11s1.17 6.559 3.982 9.37c2.811 2.811 9.37 3.982 9.37 3.982s-6.559 1.17-9.37 3.982c-2.812 2.811-3.982 9.37-3.982 9.37s-1.17-6.559-3.982-9.37C68.559 25.522 62 24.352 62 24.352s6.559-1.17 9.37-3.982c2.811-2.811 3.982-9.37 3.982-9.37Z"
      />
   </svg>
);
export default SvgDocumentGenerationPage1;
